class AnnouncementBar {
    constructor() {
        this.init();
    }
    init = () => {
        let announcement = qs('.announcement-bar-slider');
        let speed = announcement?.dataset.speed ? parseInt(announcement?.dataset.speed) * 1000 : 3000;
        let rotate = announcement?.dataset.rotate == "true" ? true : false;
        let settings = {
            spaceBetween: 30,
            loop: true,
            slidesPerView: 1,
            autoHeight: true
        }
        if (rotate) {
            // settings['centeredSlides'] = true;
            settings['slidesPerView'] = 'auto';
            settings['allowTouchMove'] = false;
            settings['disableOnInteraction'] = false;
            settings['autoHeight'] = false;
            settings['speed'] = speed;
            settings['autoplay'] = {
                delay: 10,
            };
        }
        if(!rotate){
            settings['navigation'] = {
                nextEl: qs('.swiper-button-next',announcement),
                prevEl: qs('.swiper-button-prev',announcement)
            }
        }
        const swiper = new Swiper(announcement, settings);
    }
}
if (document.querySelector('.announcement-bar-slider.swiper')) new AnnouncementBar();